import { isRefusedDirectDebit, hasItemOngoing, hasAnyOverdueTransactionWithOngoingDd, hasAtLeastOneOngoingDocument, } from './transactionService';
import { isDirectDebitPaymentMethod, isManualPaymentMethod } from './billingAccountsService';
/**
 * Indicates whether the pay button should be displayed at PoP level.
 * Cf. https://confluenceprd-proximuscorp.msappproxy.net/display/eServicesRevamp/Overview+-+Reskin#Overview-Reskin-5.2.3POPlevel
 */
export function shouldDisplayPayButtonAtPopLevel(overdueBalance, balance, pop, billingTransaction, paymentInfo, language) {
    var _a, _b, _c, _d, _e;
    if (overdueBalance === 0 ||
        hasItemOngoing(billingTransaction) ||
        hasAnyOverdueTransactionWithOngoingDd(billingTransaction)) {
        return false;
    }
    const hasMoreThanOneOpenTransaction = ((_d = (_c = (_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions) === null || _b === void 0 ? void 0 : _b.billingDocuments) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 1;
    const hasManualPayment = ((_e = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.result) === null || _e === void 0 ? void 0 : _e.paymentMethod) !== undefined &&
        isManualPaymentMethod(paymentInfo.result.paymentMethod);
    return (hasDirectDebitAndAtleastOneRefusedDirectDebitTransaction(paymentInfo, billingTransaction) ||
        (hasMoreThanOneOpenTransaction &&
            hasManualPayment &&
            balance !== overdueBalance &&
            hasPopMessage(pop, language)));
}
function hasDirectDebitAndAtleastOneRefusedDirectDebitTransaction(paymentInfo, billingTransaction) {
    var _a;
    return (isDirectDebitPaymentMethod((_a = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.result) === null || _a === void 0 ? void 0 : _a.paymentMethod) &&
        isRefusedDirectDebit(billingTransaction));
}
/**
 * Indicates if the pop call should be triggered.
 * @param overdueBalance
 * @param openTransactions
 * @returns True if pop call should be done.
 */
export function shouldDoPopCall(overdueBalance, openTransactions) {
    const hasOverdueBalance = (Number(overdueBalance) || 0.0) > 0;
    return hasOverdueBalance && !hasAtLeastOneOngoingDocument(openTransactions);
}
export function shouldDisplayPopMessage(pop, language, overdueBalance, openTransactions) {
    return shouldDoPopCall(overdueBalance, openTransactions) && hasPopMessage(pop, language);
}
export function hasPopMessage(pop, language) {
    var _a;
    return Boolean((_a = pop.result) === null || _a === void 0 ? void 0 : _a.collectionMessage[language]);
}
